'use strict';

require('../configuration/menus.js');
require('../configuration/sidebar.js');
require('../configuration/messages.js');
